export default __webpack_public_path__ + "static/media/runnerup_2.217af9d9.jpg";